import { configureStore, Store, AnyAction } from "@reduxjs/toolkit"
import { rootReducer } from "./rootReducer"
import { bikeFleetMiddleware } from "features/bikeFleet/slice/bikeFleetMiddleware"
export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).concat(bikeFleetMiddleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = Store<RootState, AnyAction>
